import { convertToEtcGMTFormat } from "./convertToEtcGMTFormat";

// Функция для определения часового пояса
export const getDefaultTimezone = () => {
    // Получаем часовой пояс браузера (например: "Europe/Moscow")
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log(convertToEtcGMTFormat(browserTimezone))
    // Преобразуем в формат Etc/GMT-*
    return convertToEtcGMTFormat(browserTimezone);
}